import { colorLookup } from '@medifind/utils';

const IconTiersCircle = ({ size = 32 }) => {
  const colorTier1 = colorLookup('tier1');
  const colorTier2 = colorLookup('tier2');
  const colorTier3 = colorLookup('tier3');
  const colorTier4 = colorLookup('tier4');

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 24V32C24.8366 32 32 24.8366 32 16H24C24 20.4183 20.4183 24 16 24Z"
        fill={colorTier4}
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M32 16H24C24 11.5817 20.4183 8 16 8V0C24.8366 0 32 7.16344 32 16Z" fill={colorTier3} />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 8V0C7.16344 0 0 7.16344 0 16H8C8 11.5817 11.5817 8 16 8Z" fill={colorTier2} />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 24C11.5817 24 8 20.4183 8 16H0C0 24.8366 7.16344 32 16 32V24Z" fill={colorTier1} />
    </svg>
  );
};

export { IconTiersCircle as default, IconTiersCircle };
